import React from 'react'

import { FramesManager } from '../../../view/frames-manager'
import { UI2IconName, UI2IconNames } from '../../icons/ui2-icon-names'

export const UI2_BANNER_DEFAULT_PROPS: Partial<UI2BannerProps> = {
  mode: 'neutral',
}

export type BannerMode = 'success' | 'info' | 'warning' | 'danger' | 'neutral'

/**
 * Role → shape, defined once. Each platform used to keep its own copy in its
 * own icon vocabulary, so `warning` was a triangle on NM and a Blueprint
 * `warning-sign` on DW, and an author-supplied `icon` that worked on one
 * platform rendered nothing on the other.
 */
export const BANNER_MODE_ICONS: Record<BannerMode, UI2IconName> = {
  success: UI2IconNames.CIRCLE_CHECK,
  info: UI2IconNames.INFO,
  warning: UI2IconNames.TRIANGLE_ALERT,
  danger: UI2IconNames.CIRCLE_ALERT,
  neutral: UI2IconNames.INFO,
}

export interface UI2BannerProps {
  /** Visual tone. Also picks a default icon when `icon` is not provided. Defaults to 'neutral'. */
  mode?: BannerMode
  title?: string
  /** Plain-text body. Ignored when `markdownText` is provided. */
  text?: string
  /** Markdown body. Takes precedence over `text` when both are set. */
  markdownText?: string
  /** Icon override. When omitted, `BANNER_MODE_ICONS` picks one from `mode`. */
  icon?: UI2IconName
  /** Actions/controls rendered inside the banner, below the body. */
  children?: React.ReactNode
  /**
   * Local translation table. Merged over `frames.getContext('translationTable')`
   * so component-level entries override the ambient table.
   */
  translationTable?: Record<string, string>
  /** Renderer frames; supplies the ambient translation table when present. */
  frames?: FramesManager
}
